import React, { useState } from "react";
import { Box } from "@towersystems/towersystems-design-system";
import { TowerProvider } from "@towersystems/towersystems-design-system";
import { ButtonV2 } from "components/button-v2";
import { Text } from "components/text";

import "./styles.scss";

const DeleteConfirmPrompt = ({
  dashboardId,
  onClose,
  message,
  title,
  ...props
}) => {
  const [deleting, setDeleting] = useState(false);

  return (
    <TowerProvider>
      <Box className="react-confirm-alert-body">
        <Box align="center">
          <Text variant="headingXs" size="large" weight="medium" align="center">
            {title}
          </Text>
        </Box>
        <Box align="center">
          <Text variant="headingXxs" align="center" tone="subdued">
            {message}
          </Text>
        </Box>
        <Box marginTop="xlarge">
          <div className="flex gap-3 justify-center">
            <ButtonV2
              fullWidth
              variant="destructive"
              onClick={async () => {
                setDeleting(true);
                await props.deleteDashboard(dashboardId);
                onClose();
              }}
              disabled={deleting}
            >
              Yes
            </ButtonV2>

            <ButtonV2 fullWidth onClick={onClose} secondary lined>
              Cancel
            </ButtonV2>
          </div>
        </Box>
      </Box>
    </TowerProvider>
  );
};

export default DeleteConfirmPrompt;
